/* The contents of this file are generated automatically during the build process of this component.
 * If you need to make changes on these styles, go to the .scss files of this repository.
 * Once you are done, run the "npm run build" script to update this file and commit your changes, including this file.
*/

import '@webcomponents/shadycss/entrypoints/apply-shim.js';

const styleElement = document.createElement('dom-module');
styleElement.innerHTML =
`<template>
<style>
/*CSS-START*/
:host {
  display: block;
  position: relative;
  width: 100%;
  line-height: normal;
  color: var(--primary-dark);
  font-family: var(--wdpr-single-select-font-family, var(--font-base_-_font-family));
  font-weight: var(--wdpr-single-select-font-weight, var(--font-base_-_font-weight, 400));
  box-sizing: var(--wdpr-single-select-box-sizing, initial);
}

@media only screen and (min-width: 481px) {
  :host {
    max-width: var(--wdpr-single-select-max-width, 240px);
  }
}

/* Common styles for the down arrow icon */
/* Native dropdown specific styles */
.native-dropdown-container {
  position: relative;
}

.native-dropdown-container .label {
  font-size: var(--wdpr-single-select-label-font-size, 12px);
  line-height: var(--wdpr-single-select-label-line-height, 16px);
  height: var(--wdpr-single-select-label-line-height, 16px);
  color: var(--wdpr-single-select-label-color, var(--primary-message));
  position: var(--wdpr-single-select-label-position-native, static);
  top: var(--wdpr-single-select-label-top-native, auto);
  padding: var(--wdpr-single-select-label-padding-native);
}

.native-dropdown-container .select-and-icon-container {
  position: relative;
}

.native-dropdown-container .native-select {
  color: var(--wdpr-single-select-color, var(--primary-message));
  position: relative;
  border-width: var(--wdpr-single-select-border-width, 0px 0px 1px 0px);
  border-style: solid;
  border-color: var(--wdpr-single-select-border-color, var(--secondary-message-detail));
  border-radius: var(--wdpr-single-select-border-radius, 0px);
  min-height: var(--wdpr-single-select-min-height-native, var(--wdpr-single-select-min-height, 30px));
  width: 100%;
  appearance: none;
  background-color: var(--wdpr-single-select-native-background-color, initial);
  line-height: normal;
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: var(--wdpr-single-select-native-padding, 0px 20px 0px 0px);
  z-index: var(--wdpr-single-select-native-z-index, auto);
  font-family: var(--wdpr-single-select-native-font-family, var(--font-light_-_font-family));
  font-weight: var(--wdpr-single-select-native-font-weight, var(--font-light_-_font-weight));
  @apply --font16;
  /* This hides the select arrow in IE */
}

.native-dropdown-container .native-select::-ms-expand {
  display: none;
}

.native-dropdown-container .native-select:active, .native-dropdown-container .native-select:focus, .native-dropdown-container .native-select.opened {
  color: var(--wdpr-single-select-active-color, var(--primary-dark)) !important;
  border-color: var(--wdpr-single-select-active-border-color, unset unset var(--primary-dark) unset) !important;
  border-width: var(--wdpr-single-select-active-border-width, var(--wdpr-single-select-border-width, 0px 0px 1px 0px));
}

.native-dropdown-container .native-select:active + i, .native-dropdown-container .native-select:focus + i, .native-dropdown-container .native-select.opened + i {
  color: var(--wdpr-single-select-active-color, var(--primary-dark));
}

.native-dropdown-container .native-select.item-selected {
  color: var(--wdpr-single-select-selected-color, var(--primary-dark));
  padding: var(--wdpr-single-select-native-padding-with-item-selected, --wdpr-single-select-native-padding, 0px 20px 0px 0px);
}

.native-dropdown-container i {
  position: absolute;
  right: var(--wdpr-single-select-icon-right, 0px);
  top: var(--wdpr-single-select-icon-top, 50%);
  transform: translateY(-50%);
  color: var(--wdpr-single-select-icon-color, var(--secondary-message));
  font-size: var(--wdpr-single-select-icon-font-size, 16px);
  line-height: var(--wdpr-single-select-icon-line-height, var(--font16-line-height));
  right: var(--wdpr-single-select-icon-right-native, var(--wdpr-single-select-icon-right, 0px));
  top: var(--wdpr-single-select-icon-top-native, var(--wdpr-single-select-icon-top, 50%));
  /* Set bg color to white here if native select arrows are visible */
}

.native-dropdown-container:hover .native-select {
  color: var(--wdpr-single-select-hover-color, var(--secondary-hover)) !important;
  border-color: var(--wdpr-single-select-hover-border-color, unset unset var(--secondary-hover) unset);
  border-width: var(--wdpr-single-select-hover-border-width, var(--wdpr-single-select-border-width, 0px 0px 1px 0px));
}

.native-dropdown-container:hover .label {
  color: var(--wdpr-single-select-hover-label-color, var(--secondary-hover)) !important;
}

.native-dropdown-container:hover i {
  color: var(--wdpr-single-select-hover-icon-color, var(--secondary-hover)) !important;
}

.native-dropdown-container.invalid .label {
  color: var(--wdpr-single-select-invalid-label-color, var(--primary-alert)) !important;
}

.native-dropdown-container.invalid .native-select {
  color: var(--wdpr-single-select-invalid-color, var(--primary-alert)) !important;
  border-color: var(--wdpr-single-select-invalid-border-color, unset unset var(--primary-alert) unset) !important;
  border-width: var(--wdpr-single-select-invalid-border-width, var(--wdpr-single-select-border-width, 0px 0px 1px 0px));
}

.native-dropdown-container.invalid .native-select + i {
  color: var(--wdpr-single-select-invalid-icon-color, var(--primary-alert));
}

.native-dropdown-container.disabled .label {
  color: var(--wdpr-single-select-disabled-color, #e0e0e0);
}

.native-dropdown-container.disabled .native-select {
  background-color: var(--wdpr-single-select-disabled-background-color, unset);
  color: var(--wdpr-single-select-disabled-color, #e0e0e0) !important;
  border-color: var(--wdpr-single-select-disabled-border-color, unset unset var(--wdpr-single-select-disabled-color, #e0e0e0) unset) !important;
  border-width: var(--wdpr-single-select-disabled-border-width, var(--wdpr-single-select-border-width, 0px 0px 1px 0px));
}

.native-dropdown-container.disabled .native-select + i {
  color: var(--wdpr-single-select-disabled-color, #e0e0e0);
}

/* Custom dropdown specific styles */
.custom-dropdown-container .trigger-button {
  position: relative;
  width: 100%;
  min-height: var(--wdpr-single-select-min-height, 30px);
  color: var(--wdpr-single-select-color, var(--primary-message));
  background-color: transparent;
  line-height: normal;
  text-align: left;
  padding: var(--wdpr-single-select-custom-padding, 0px 0px 3px 0px);
  border-width: var(--wdpr-single-select-border-width, 0px 0px 1px 0px);
  border-style: solid;
  border-color: var(--wdpr-single-select-border-color, var(--secondary-message-detail));
  border-radius: var(--wdpr-single-select-border-radius, 0px);
  cursor: pointer;
  appearance: none;
  font-family: var(--wdpr-single-select-trigger-button-font-family, var(--font-light_-_font-family));
  font-weight: var(--wdpr-single-select-trigger-button-font-weight, var(--font-light_-_font-weight));
  @apply --font16;
}

.custom-dropdown-container .trigger-button .label {
  font-size: var(--wdpr-single-select-label-font-size, 12px);
  line-height: var(--wdpr-single-select-label-line-height, 16px);
  height: var(--wdpr-single-select-label-line-height, 16px);
  color: var(--wdpr-single-select-label-color, var(--primary-message));
}

.custom-dropdown-container .trigger-button i {
  position: absolute;
  right: var(--wdpr-single-select-icon-right, 0px);
  top: var(--wdpr-single-select-icon-top, 50%);
  transform: translateY(-50%);
  color: var(--wdpr-single-select-icon-color, var(--secondary-message));
  font-size: var(--wdpr-single-select-icon-font-size, 16px);
  line-height: var(--wdpr-single-select-icon-line-height, var(--font16-line-height));
}

.custom-dropdown-container .trigger-button .button-text-container {
  position: relative;
  height: var(--wdpr-single-select-trigger-button-text-box-height, var(--wdpr-single-select-custom-option-item-height, 24px));
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: var(--wdpr-single-select-custom-icon-padding-right, 20px);
  top: var(--wdpr-single-select-no-item-selected-text-container-top, 0px);
}

.custom-dropdown-container .trigger-button .button-text-container.has-image {
  height: 50px;
  padding: var(--wdpr-single-select-custom-guestlist-padding, 0 10px 5px);
}

.custom-dropdown-container .trigger-button .button-text-container.has-image .selected-icon {
  font-size: var(--wdpr-single-select-label-selected-icon-font-size, 50px);
  width: 50px;
  position: relative;
  top: 10px;
  float: left;
}

.custom-dropdown-container .trigger-button .button-text-container.has-image .guestlist-buttontext {
  top: 13px;
  position: relative;
  float: left;
  left: 20px;
}

.custom-dropdown-container .trigger-button .button-text-container.has-image .guest-avatar {
  float: left;
  height: 100%;
  width: auto;
}

.custom-dropdown-container .trigger-button:hover {
  color: var(--wdpr-single-select-hover-color, var(--secondary-hover)) !important;
  border-color: var(--wdpr-single-select-hover-border-color, unset unset var(--secondary-hover) unset);
  border-width: var(--wdpr-single-select-hover-border-width, var(--wdpr-single-select-border-width, 0px 0px 1px 0px));
  padding: var(--wdpr-single-select-hover-custom-padding, var(--wdpr-single-select-custom-padding, 0px 0px 3px 0px));
}

.custom-dropdown-container .trigger-button:hover .label {
  color: var(--wdpr-single-select-hover-label-color, var(--secondary-hover)) !important;
}

.custom-dropdown-container .trigger-button:hover i {
  color: var(--wdpr-single-select-hover-icon-color, var(--secondary-hover)) !important;
}

.custom-dropdown-container .trigger-button:active, .custom-dropdown-container .trigger-button:focus, .custom-dropdown-container .trigger-button.opened {
  color: var(--wdpr-single-select-active-color, var(--primary-dark)) !important;
  border-color: var(--wdpr-single-select-active-border-color, unset unset var(--primary-dark) unset) !important;
  border-width: var(--wdpr-single-select-active-border-width, var(--wdpr-single-select-border-width, 0px 0px 1px 0px));
  padding: var(--wdpr-single-select-active-custom-padding, var(--wdpr-single-select-custom-padding, 0px 0px 3px 0px));
}

.custom-dropdown-container .trigger-button:active .label, .custom-dropdown-container .trigger-button:focus .label, .custom-dropdown-container .trigger-button.opened .label {
  color: var(--wdpr-single-select-active-label-color, var(--primary-dark)) !important;
}

.custom-dropdown-container .trigger-button:active i, .custom-dropdown-container .trigger-button:focus i, .custom-dropdown-container .trigger-button.opened i {
  color: var(--wdpr-single-select-active-color, var(--primary-dark)) !important;
}

.custom-dropdown-container .trigger-button.item-selected {
  color: var(--wdpr-single-select-selected-color, var(--primary-dark));
}

.custom-dropdown-container .trigger-button.item-selected .button-text-container {
  top: var(--wdpr-single-select-item-selected-text-container-top, 0px);
}

.custom-dropdown-container .trigger-button.item-selected i {
  color: var(--wdpr-single-select-icon-selected-color, var(--secondary-message));
  top: var(--wdpr-single-select-icon-selected-top, var(--wdpr-single-select-icon-top, 50%));
}

.custom-dropdown-container .trigger-button.invalid {
  color: var(--wdpr-single-select-invalid-color, var(--primary-alert)) !important;
  border-color: var(--wdpr-single-select-invalid-border-color, unset unset var(--primary-alert) unset) !important;
  border-width: var(--wdpr-single-select-invalid-border-width, var(--wdpr-single-select-border-width, 0px 0px 1px 0px));
  padding: var(--wdpr-single-select-invalid-custom-padding, var(--wdpr-single-select-custom-padding, 0px 0px 3px 0px));
}

.custom-dropdown-container .trigger-button.invalid .label {
  color: var(--wdpr-single-select-invalid-label-color, var(--primary-alert)) !important;
}

.custom-dropdown-container .trigger-button.invalid i {
  color: var(--wdpr-single-select-invalid-icon-color, var(--primary-alert)) !important;
}

.custom-dropdown-container .trigger-button.disabled {
  background-color: var(--wdpr-single-select-disabled-background-color, unset);
  color: var(--wdpr-single-select-disabled-color, #e0e0e0) !important;
  border-color: var(--wdpr-single-select-disabled-border-color, unset unset var(--wdpr-single-select-disabled-color, #e0e0e0) unset) !important;
  border-width: var(--wdpr-single-select-disabled-border-width, var(--wdpr-single-select-border-width, 0px 0px 1px 0px));
  padding: var(--wdpr-single-select-disabled-custom-padding, var(--wdpr-single-select-custom-padding, 0px 0px 3px 0px));
  cursor: default;
}

.custom-dropdown-container .trigger-button.disabled .label,
.custom-dropdown-container .trigger-button.disabled i {
  color: var(--wdpr-single-select-disabled-color, #e0e0e0) !important;
}

.custom-dropdown-container .options-list {
  position: absolute;
  margin: var(--wdpr-single-select-custom-options-list-margin, 0px);
  list-style: none;
  width: 100%;
  padding: var(--wdpr-single-select-custom-options-list-padding, 0px);
  box-sizing: border-box;
  border-style: solid;
  border-width: var(--wdpr-single-select-custom-options-list-border-width, 1px);
  border-color: var(--wdpr-single-select-custom-options-list-border-color, var(--secondary-message-detail));
  border-radius: var(--wdpr-single-select-custom-options-list-border-radius, 0px);
  background: var(--wdpr-single-select-custom-options-list-background-color, white);
  max-height: var(--wdpr-single-select-custom-options-list-max-height, 290px);
  overflow-y: auto;
  z-index: 1;
}

.custom-dropdown-container .options-list.hidden {
  display: none;
}

.custom-dropdown-container .options-list li:nth-last-of-type(1) {
  color: var(--wdpr-single-select-custom-options-list-last-option-color, var(--primary-dark));
}

.custom-dropdown-container .options-list li:nth-last-of-type(1):hover {
  background: var(--secondary-hover);
  color: white;
}

.custom-dropdown-container .options-list li:nth-last-of-type(1):hover img {
  border: var(--wdpr-single-select-custom-image-border, 1px white solid);
}

.custom-dropdown-container .options-list .option-item {
  color: var(--wdpr-single-select-option-item-color, var(--primary-dark));
  padding: var(--wdpr-single-select-custom-option-item-padding, 12px);
  height: var(--wdpr-single-select-custom-option-item-height, 24px);
  cursor: pointer;
  white-space: var(--wdpr-single-select-custom-option-item-white-space, nowrap);
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: content-box;
  font-family: var(--wdpr-single-select-option-item-font-family, var(--font-base_-_font-family));
  font-weight: var(--wdpr-single-select-option-item-font-weight, var(--font-base_-_font-weight, 400));
  @apply --font16;
}

.custom-dropdown-container .options-list .option-item:hover, .custom-dropdown-container .options-list .option-item:active, .custom-dropdown-container .options-list .option-item:focus, .custom-dropdown-container .options-list .option-item.active {
  background: var(--wdpr-single-select-option-item-hover-background-color, var(--secondary-hover));
  color: var(--wdpr-single-select-option-item-hover-color, white);
}

.custom-dropdown-container .options-list .option-item.selected {
  background: var(--wdpr-single-select-option-item-selected-background-color, var(--primary-dark));
  color: var(--wdpr-single-select-option-item-selected-color, white);
}

.custom-dropdown-container .options-list .option-item.has-image {
  height: 40px;
  padding: var(--wdpr-single-select-custom-guestlist-padding, 10px);
}

.custom-dropdown-container .options-list .option-item.has-image img {
  float: left;
  height: 100%;
  width: auto;
  border: 1px white solid;
}

.custom-dropdown-container .options-list .option-item.has-image a:hover {
  text-decoration: none;
}

.custom-dropdown-container .options-list .option-item.has-image .option-value-inner {
  position: relative;
  top: 8px;
  float: left;
  left: 20px;
}

.custom-dropdown-container .options-list .option-item.has-image .selected-icon {
  margin: 0;
  font-size: var(--wdpr-single-select-label-selected-icon-font-size, 40px);
  position: relative;
  top: 11px;
  width: 44px;
  float: left;
  color: var(--primary-dark);
}

.custom-dropdown-container .options-list .option-item.has-image.selected .selected-icon {
  color: var(--primary);
}

.custom-dropdown-container .options-list .option-item.add-guest {
  padding: 0;
  height: 100%;
}

.custom-dropdown-container .options-list .option-item.add-guest:hover a, .custom-dropdown-container .options-list .option-item.add-guest:active a, .custom-dropdown-container .options-list .option-item.add-guest:focus a, .custom-dropdown-container .options-list .option-item.add-guest.active a {
  color: white;
  text-decoration: none;
}

.custom-dropdown-container .options-list .option-item.add-guest a {
  display: block;
  width: 100%;
  padding: var(--wdpr-single-select-add-guest-custom-padding, 12px 7px);
}

.custom-dropdown-container .options-list .option-item .add-guest-icon {
  float: left;
  margin-right: 20px;
  color: var(--primary);
}

.custom-dropdown-container .options-list::-webkit-scrollbar {
  width: var(--wdpr-single-select-custom-options-list-scrollbar-width, 5px);
  background: transparent;
}

.custom-dropdown-container .options-list::-webkit-scrollbar-thumb {
  width: var(--wdpr-single-select-custom-options-list-scrollbar-width, 5px);
  background-color: var(--wdpr-single-select-scrollbar-color, var(--secondary-message));
  border-radius: var(--wdpr-single-select-custom-options-list-scrollbar-border-radius, 10px);
}

.custom-dropdown-container .options-list::-webkit-scrollbar-thumb:hover {
  background: var(--wdpr-single-select-scrollbar-color, var(--secondary-message));
}

.custom-dropdown-container .options-list::-webkit-scrollbar-track, .custom-dropdown-container .options-list::-webkit-scrollbar-track-piece {
  background: transparent;
}

.age-label {
  display: block;
  font-size: var(--wdpr-single-select-label-age-label-font-size, 10px);
  line-height: var(--wdpr-single-select-label-age-label-line-height, 7px);
}

.avatar-rounded {
  border-radius: 50%;
}

.option-disabled {
  opacity: 0.5;
}

/* Utilities */
.invisible {
  visibility: hidden;
}
/*CSS-END*/
</style>
</template>`;

styleElement.register('wdpr-single-select-style');
